import React from "react";
import { SaveButton, Toolbar, useTranslate } from "react-admin";
import { useFormState } from "react-final-form";

import { OrderService } from "../../entities/OrderService";
import { BackButton } from "./BackButton";
import { SaveToEditButton } from "./SaveToEditButton";
import { SaveWithWarningsButton } from "./SaveWithWarningsButton";

export const SaveButtonWithSaveToEditWithCancelToolbar = ({
	children,
	warningValidations,
	...props
}) => {
	const { values, initialValues } = useFormState();
	const t = useTranslate();
	return (
		<Toolbar {...props}>
			{warningValidations ? (
				<SaveWithWarningsButton warningValidations={warningValidations} />
			) : (
				<SaveButton />
			)}
			<SaveToEditButton label={t("osfc.buttons.save_and_edit_and_add_documents")} />
			{values?.service === OrderService.coldStorage && (
				<SaveToEditButton label={t("osfc.buttons.save_and_edit_and_add_products")} />
			)}
			<BackButton />
			{children}
		</Toolbar>
	);
};
